<template>
  <div class="parent-login">
    <div class="login-card card">
      <h2>家长登录</h2>
      <p class="desc">手机号 + 密码登录，仅可查看自家孩子课时</p>

      <div v-if="isLoggedIn" class="logged-info">
        <p>已登录：{{ loggedName }} 家长</p>
        <el-button type="success" @click="$router.push('/records')">查看课时</el-button>
        <el-button @click="handleLogout">退出登录</el-button>
      </div>

      <el-form v-else :model="form" ref="form" label-width="0">
        <el-form-item>
          <el-input v-model="form.clubCode" prefix-icon="el-icon-office-building" placeholder="俱乐部编码（如 yuedong）" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.phone" prefix-icon="el-icon-phone" placeholder="家长手机号" maxlength="11" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" placeholder="密码（向俱乐部索取）" show-password @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="privacyAgreed">我已阅读并同意</el-checkbox>
          <router-link to="/privacy" class="privacy-link">《用户隐私保护指引》</router-link>
        </el-form-item>
        <el-button type="success" :loading="loading" style="width:100%" @click="handleLogin">登 录</el-button>
      </el-form>

      <div class="links">
        <router-link to="/">返回首页</router-link>
        <router-link to="/about">服务说明</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { parentLogin, parentLogoutApi } from '../../api'
import { isParentLoggedIn, getParentName, saveParentLogin, parentLogout } from '../../utils/auth'

export default {
  name: 'ParentLogin',
  data() {
    return {
      form: {
        clubCode: localStorage.getItem('club_code') || '',
        phone: '',
        password: ''
      },
      loading: false,
      privacyAgreed: false,
      isLoggedIn: false,
      loggedName: '',
      redirectRecords: false
    }
  },
  mounted() {
    this.redirectRecords = this.$route.query.redirect === 'records'
    if (isParentLoggedIn()) {
      this.isLoggedIn = true
      this.loggedName = getParentName()
    }
  },
  methods: {
    async handleLogin() {
      if (!this.privacyAgreed) {
        this.$message.warning('请先勾选同意隐私协议')
        return
      }
      const phone = (this.form.phone || '').trim()
      const password = (this.form.password || '').trim()
      const clubCode = (this.form.clubCode || '').trim()
      if (!clubCode) {
        this.$message.warning('请填写俱乐部编码')
        return
      }
      if (!/^1\d{10}$/.test(phone)) {
        this.$message.warning('请输入正确的11位手机号')
        return
      }
      if (!password) {
        this.$message.warning('请输入密码')
        return
      }
      this.loading = true
      try {
        const res = await parentLogin(phone, password, clubCode)
        const data = res.data || {}
        saveParentLogin(data.token, data.parentName, data.children || [])
        if (data.clubCode) localStorage.setItem('club_code', data.clubCode)
        this.$message.success('登录成功')
        setTimeout(() => {
          this.$router.push('/records')
        }, 400)
      } finally {
        this.loading = false
      }
    },
    handleLogout() {
      this.$confirm('确定退出家长账号？', '退出登录').then(async () => {
        try { await parentLogoutApi() } catch (e) { /* ignore */ }
        parentLogout()
        this.isLoggedIn = false
        this.loggedName = ''
        this.privacyAgreed = false
        this.$message.success('已退出')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.parent-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px;
}
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 32px 24px;
}
.card { background: #fff; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
h2 { text-align: center; margin-bottom: 8px; }
.desc { text-align: center; color: #999; font-size: 14px; margin-bottom: 24px; }
.logged-info { text-align: center; }
.logged-info p { margin-bottom: 16px; }
.privacy-link { color: #409EFF; font-size: 13px; margin-left: 4px; text-decoration: none; }
.links { display: flex; justify-content: center; gap: 16px; margin-top: 20px; font-size: 13px; }
.links a { color: #409EFF; text-decoration: none; }
</style>
